import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface GridSelectionLimitControlProps {
  totalMatching: number | null;
  value: string;
  showSelectAllMatching: boolean;
  onChange: (value: string) => void;
  onBlur: () => void;
}

const GridSelectionLimitControl = ({
  totalMatching,
  value,
  showSelectAllMatching,
  onChange,
  onBlur,
}: GridSelectionLimitControlProps) => (
  <label
    className={cn(
      "inline-flex h-8 items-center gap-2 rounded-lg border border-slate-200 bg-white px-2.5 text-sm text-slate-700 shadow-sm shadow-slate-200/60 transition-colors hover:border-slate-300 hover:bg-slate-50",
      showSelectAllMatching && "rounded-l-none border-l-0",
    )}
  >
    <span className="whitespace-nowrap text-xs font-medium text-slate-500">Limit:</span>
    <Input
      aria-label="Select all limit"
      className="!h-6 !w-[6ch] !rounded-none !border-0 !bg-transparent !p-0 text-right !text-xs !font-semibold text-slate-900 !shadow-none !outline-none !ring-0 [appearance:textfield] placeholder:text-slate-400 focus:!border-0 focus:!outline-none focus:!ring-0 focus-visible:!outline-none focus-visible:!ring-0 focus-visible:!ring-offset-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
      min={1}
      max={totalMatching ?? undefined}
      type="number"
      value={value}
      placeholder={totalMatching?.toLocaleString()}
      onChange={e => onChange(e.target.value)}
      onBlur={onBlur}
      onKeyDown={e => {
        if (e.key === "Enter") {
          e.currentTarget.blur();
        }
      }}
    />
  </label>
);

export default GridSelectionLimitControl;
